import { getLanguageLabel } from 'src/utils/bookLanguageLabels'

const VARIANT_SUFFIX_LABELS: Record<string, string> = {
	us: 'US',
	uk: 'UK',
	gb: 'UK',
	north: 'North',
	south: 'South',
}

export const getVariantLabel = (
	languageVariant?: string | null,
	baseLanguage?: string | null,
): string => {
	if (!languageVariant) {
		return getLanguageLabel(baseLanguage)
	}

	const normalized = languageVariant.toLowerCase().trim().replace(/_/g, '-')
	const base = getLanguageLabel(baseLanguage ?? normalized.split('-')[0])
	const suffix = normalized.split('-').slice(1).join('-')
	const suffixLabel = VARIANT_SUFFIX_LABELS[suffix] ?? suffix.toUpperCase()

	return suffix ? `${base} (${suffixLabel})` : base
}

export const getVariantRegenerateKey = (bookAudioId: string) => bookAudioId
